import { render } from "./IconLocale.vue?vue&type=template&id=df0248ea&lang=html"
import script from "./IconLocale.vue?vue&type=script&lang=js"
export * from "./IconLocale.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__